import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from "../../../services/authentication.service";

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})

export class HelpComponent implements OnInit {
  user = {};

  constructor(@Inject('AuthenticationService') private readonly authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
  }

}
